import { __decorate } from "tslib";
import { Api } from '../../lib/api.factory';
import { ApiResource } from '../../lib/api-decorators';
let CrawlerResource = class CrawlerResource extends Api {
    crawlMetadata(url) {
        return this.post('/metadata', { url });
    }
    crawlSource(sourceKey) {
        return this.post('/source/crawl', { key: sourceKey });
    }
    searchSources(type, query) {
        return this.get('/source/search', { type, query });
    }
    getSource(type, name) {
        return this.get('/source', { type, name });
    }
    getArticles(type, name, sorting, subsource) {
        return this.get('/source/articles', { type, name, sorting, subsource });
    }
};
CrawlerResource = __decorate([
    ApiResource('/crawler')
], CrawlerResource);
export { CrawlerResource };
